// components/consoleLogger.tsx

import { useEffect } from 'react';
import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { userAttributes } from "./instrumentation";
import { getResource } from './resource';
import type * as logsAPI from '@opentelemetry/api-logs';
import { Exception } from '@opentelemetry/api/build/src';
import { trace, context, propagation } from "@opentelemetry/api";

var Logger: logsAPI.Logger;
const extractSourceLocation = (stack?: string): string => {
  if (!stack) return '';
  const lines = stack.split('\n');
  return lines.length > 2 ? lines[2].trim() : 'unknown location';
};
const ConsoleLogger = () => {
  useEffect(() => {
    const loggerProvider = new LoggerProvider({
      resource: getResource(),
    });

    const exporter = new OTLPLogExporter({
      url: 'https://tracer.rupeezy.in/v1/logs',
    });

    loggerProvider.addLogRecordProcessor(new BatchLogRecordProcessor(exporter));
    Logger = loggerProvider.getLogger('browser-console-logger');

    const levels = ['info', 'warn', 'error'] as const;

    levels.forEach((level) => {
      const original = console[level];
      console[level] = (...args: any[]) => {
        const currentSpan = trace.getSpan(context.active()); // Capture span context properly
        const traceId = currentSpan?.spanContext().traceId || "unknown-trace";

        original.apply(console, args);
        let errorType = 'GeneralError'; // Default type

        if (args[0] instanceof Error) {
          errorType = args[0].name;
        }

        const stack = new Error().stack;
        const sourceLocation = extractSourceLocation(stack);
        Logger.emit({
          severityText: level.toUpperCase(),
          body: args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg) : arg)).join(' '),
          attributes: {
            source: 'browser-console',
            level,
            stackTrace: stack,
            location: sourceLocation,
            errorType: errorType,
            ...userAttributes,
          },
        });
      };
    });
  }, []);

  return null;
};

export default ConsoleLogger;